
import AddLicenseModalView from "./addLicenseModal.html";

angular.module("users")

    .controller("UsersListCtrl", ['LoginService', '$rootScope', '$scope', '$http', 'Restangular', 'gridService', 'modalService', '$filter', '$state', 'uiGridExporterConstants', 'logService', '$uibModal', function (LoginService, $rootScope, $scope, $http, Restangular, gridService, modalService, $filter, $state, uiGridExporterConstants, logService, $uibModal) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("USERS_WRITE");


        $rootScope.title = $filter('translate')('users.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('users.list') }
        ];

        logService.debug($rootScope);
        let id = $rootScope.company_id;

        $scope.getLicenses = function () {
            Restangular.all(`Companies/${id}/Licenses`).getList().then(function (licenses) {
                $scope.licencias = licenses;
            });
        }

        $scope.getLicenses();

        $scope.gridOptions = {
            exporterMenuCsv: true,
            enableGridMenu: true,
            //gridMenuShowHideColumns: false,
            paginationPageSizes: [15, 30, 45],
            pdfTitle: $filter('translate')('users.title'),
            paginationPageSize: 45,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
              { name: 'id', visible: false, exporterSuppressExport: true, displayName: $filter('translate')('users.id') },
              {
                  field: 'FK_users_images.image_small', visible: false,
                  customFormatFn: function (value) {
                      if (value != null) {
                          var img = {
                              image: value,
                              width: 30
                          };
                          return img;
                      } else {
                          return "";
                      }
                  },
                  displayName: $filter('translate')('users.icon'), cellTemplate: "<img width=\"30px\" ng-show=\"grid.getCellValue(row, col)\"  ng-src=\"{{grid.getCellValue(row, col)}}\" style=\"margin-left:10px;margin-top:5px;\" lazy-src>", width: 70, enableFiltering: false
              },
              { name: 'name', displayName: $filter('translate')('users.name'), enableFiltering: true, enableHiding: false },
                { name: 'username', enableFiltering: true, displayName: $filter('translate')('users.user') },
                { name: 'users_groups.name', enableFiltering: true, displayName: $filter('translate')('users.group') },
                { name: 'mail', enableFiltering: true, displayName: $filter('translate')('users.mail') },
                { name: 'active', enableFiltering: true, displayName: $filter('translate')('users.active'), width: 75, cellTemplate: "<div class=\"ui-grid-cell-contents\" style=\"text-align: center;\">" +
                    "<span ng-if=\"!row.entity.active\" class=\"label label-danger\" style=\"display: inline-block;height: 15px;width: 15px;border-radius: 50%;\"></span>" +
                    "<span ng-if=\"row.entity.active\" class=\"label label-primary\" style=\"display: inline-block;height: 15px;width: 15px;border-radius: 50%;\"></span>" +
                    "</div>" },
                { name: 'mfa_optional', enableFiltering: true, displayName: $filter('translate')('users.mfa_optional'), width: 110, cellTemplate: "<div class=\"ui-grid-cell-contents\" style=\"text-align: center;\">" +
                    "<span ng-if=\"row.entity.mfa_optional\" class=\"label label-warning\">{{'users.mfa_optional' | translate}}</span>" +
                    "</div>" },
                { name: 'type', enableFiltering: true, displayName: $filter('translate')('users.type'), cellTemplate: '<div>{{"users.type_" + row.entity.type | translate }}</div>' },
                { name: 'activation_pending', enableFiltering: false, displayName: $filter('translate')('users.activation_column'), width: 110, cellTemplate: '<div class="ui-grid-cell-contents"><span class="label label-warning" ng-if="row.entity.activation_pending">{{"users.activation_pending_short" | translate}}</span></div>' },

              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('users.edit'), action: 'ui-sref="users.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('users.delete'), action: 'ng-click="grid.appScope.BorrarDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
              //'<div class="ui-grid-cell-contents ng-scope" style="margin:0 auto;text-align:center;"><a class="btn btn-xs btn-primary" ui-sref="persons_types.edit({id: row.entity.id})" "><i class="fa fa-pencil"></i>Editar</a></div>'
            ],
            getData: function (options) {
                logService.debug(Restangular.all('Users'));
                return Restangular.all('Users').getList(options).then(function (r) {
                    return r;

                });
            }

        };

        $scope.addLicense = function () {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: AddLicenseModalView,
                    size: "lg",
                    controller: "AddLicenseModalCtrl",
                    resolve: function () { }
                });
            };

        // Binary string (one char per byte) built in chunks to stay below the call stack argument limit.
        const toBinaryString = function (bytes: Uint8Array): string {
            let result = '';
            for (let i = 0; i < bytes.length; i += 0x8000) {
                result += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000) as unknown as number[]);
            }
            return result;
        };

        // The server picks the reader by mime (same criteria as Persons/ImportCSV), so it is derived from the
        // extension: file.type is unreliable. Browsers on Windows with Excel installed report .csv files as
        // application/vnd.ms-excel (which the server would read as a binary workbook), and machines without an
        // Office mapping report an empty type for .xlsx/.xls.
        const mimeFromExtension = function (fileName: string): string {
            const name = (fileName || '').toLowerCase();
            if (name.endsWith('.xlsx')) return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            if (name.endsWith('.xls')) return 'application/vnd.ms-excel';
            return 'text/csv';
        };

        let importCSVConfigured = false;

        let initImportCSV = function () {
            $("#frmUsersCSV").change(function () {
                const fileInput = document.querySelector('#frmUsersCSV') as HTMLInputElement;
                let file = fileInput?.files?.[0];
                if (!file) return;
                let reader = new FileReader();
                reader.onload = function (e) {
                    const codes = new Uint8Array(e.target?.result as ArrayBuffer);
                    try {
                        // The server decodes the bytes with Encoding.Default (cp1252 on the Windows servers).
                        // UTF-8 file: decode it here and send Latin-1 bytes, which that decode reads back exactly
                        // (btoa throws on characters above 0xFF, caught below).
                        // Any other file (e.g. cp1252 saved by Excel): send the raw bytes, which the same decode also reads exactly.
                        let text: string | null;
                        try {
                            text = new TextDecoder('utf-8', { fatal: true }).decode(codes);
                        } catch (decodeError) {
                            text = null;
                        }
                        // A BOM (the template has one) would end up in the first header name.
                        const payload = text === null ? toBinaryString(codes) : text.replace(/^\uFEFF/, '');
                        Restangular.all('Users/ImportCSV').post({
                            file: btoa(payload),
                            mime: mimeFromExtension(file.name)
                        }).then(function (data) {
                            if (!data.length) {
                                toastr.error($filter('translate')('users.import_empty'));
                                return;
                            }
                            $state.go('users.import', { rows: data });
                        }, function (error) {
                            toastr.error((error && error.data && error.data.Message) || $filter('translate')('users.import_invalid_file'));
                        });
                    } catch (e) {
                        // btoa throws on characters outside Latin-1 (e.g. a UTF-8 file with curly quotes or the euro sign).
                        toastr.error($filter('translate')('users.import_read_error'));
                    }
                    // Without this, uploading the corrected file under the same name would not fire "change" again.
                    fileInput.value = '';
                };
                reader.readAsArrayBuffer(file);
            });
        };

        $scope.importCSV = function () {
            if (!importCSVConfigured) {
                importCSVConfigured = true;
                initImportCSV();
            }
            $("#frmUsersCSV").trigger("click");
        };

        $scope.downloadTemplate = function () {
            const header = 'nombre;apellidos;dni;correo;cargo;grupo;tipo;roles';
            // cargo must be the name of an existing position of the company; grupo and roles are optional.
            const example = 'Ana;García Ruiz;12345678Z;ana.garcia@ejemplo.com;Jefe de protocolo;;staff;';
            // BOM so that Excel respects the accents when opening the CSV.
            const blob = new Blob(["\uFEFF" + header + "\r\n" + example + "\r\n"], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'plantilla_usuarios.csv';
            link.click();
            URL.revokeObjectURL(url);
        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("users.edit", { id: rowEntity.id });
        }

        $scope.exportToPDF = function () {
            $scope.export_row_type = 'all';
            $scope.export_column_type = 'all';

            $scope.gridOptions.gridApi.exporter.pdfExport(uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
        }

        $scope.BorrarDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('users.delete'),
                message: $filter('translate')('users.delete_message')+" " + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('Users', $scope.id).remove().then(function () {                        
                        $scope.gridOptions.data =
                             $scope.gridOptions.data.filter(function (el) { return el.id != $scope.id; });
                    }, function (response) {
                        logService.error("Error with status code", response.status);
                        alert("Error")
                    });
                }
            });

        };
    }])

    .controller("AddLicenseModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', '$rootScope', '$filter', function ($scope, $uibModalInstance, Restangular, $rootScope, $filter) {
        let id = $rootScope.company_id;

        Restangular.one("Companies", id).get().then(function (result) {
            $scope.license = result.license;
        });


        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
            };

        $scope.saveLicense = function () {
            if ($scope.license !== "") {
                //Es muy poco intuitivo, pero es la única forma que conozco de llamar a una función del controlador mediante una ruta específica.
                Restangular.all(`Companies/${id}/AddLicenses`).getList({ codedLicense: $scope.license }).then(function () {
                    $uibModalInstance.close();
                    $scope.getLicenses();
                    toastr.success($filter('translate')('users.license_updated'));
                }, function (result) {
                    $scope.errorMessage = result.message;
                });
            }
        };

}]);